export default "__VITE_ASSET__B1nl0a95__"